var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('h3',[_vm._v(_vm._s(_vm.$t('customs.inventory.import_csv')))]),_c('v-file-input',{attrs:{"label":"Choisir un fichier"},on:{"change":_vm.sendCsv},model:{value:(_vm.file),callback:function ($$v) {_vm.file=$$v},expression:"file"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }